import { render, staticRenderFns } from "./SettingProxyWidget.vue?vue&type=template&id=1868de36&scoped=true"
import script from "./SettingProxyWidget.vue?vue&type=script&lang=js"
export * from "./SettingProxyWidget.vue?vue&type=script&lang=js"
import style0 from "./SettingProxyWidget.vue?vue&type=style&index=0&id=1868de36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1868de36",
  null
  
)

export default component.exports